import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class MethodService {

  url = "https://niivsnes.humge.com";
  constructor(private http:HttpClient,private logService:LogService) {
  }
  
  getMethods():Observable<any>{
    return this.http.get(this.url+'/api/method?token='+localStorage.getItem('token'));
  }
  deleteMethod(id):Observable<any>{
    this.logService.log("Изтриване на метод "+id).subscribe();
    return this.http.delete(this.url+'/api/method/'+id+'?token='+localStorage.getItem('token'));
  }
  saveMethod(method):Observable<any>{
    this.logService.log("Добавяне на метод ").subscribe();
    return this.http.post(this.url+'/api/method?token='+localStorage.getItem('token'),method);
  }
  editMethod(id):Observable<any>{
    return this.http.get(this.url+'/api/method/'+id+'/edit?token='+localStorage.getItem('token'));
  }
  updateMethod(method,id):Observable<any>{
    this.logService.log("Промяна на метод "+id).subscribe();
    return this.http.put(this.url+'/api/method/'+id+'?token='+localStorage.getItem('token'),method);
  }


}
